import { create } from 'zustand';

type State = {
  isViewerOpen: boolean;
  currentImageUrl: string;
  currentImageAlt: string;
};

type Action = {
  setIsViewerOpen: (value: boolean) => void;
  setCurrentImageUrl: (value: string) => void;
  setCurrentImageAlt: (value: string) => void;
};

const useImageViewerStore = create<State & Action>((set) => ({
  isViewerOpen: false,
  setIsViewerOpen: (value: boolean) => set({ isViewerOpen: value }),
  currentImageUrl: '',
  setCurrentImageUrl: (value: string) => set({ currentImageUrl: value }),
  currentImageAlt: '',
  setCurrentImageAlt: (value: string) => set({ currentImageAlt: value }),
}));

export default useImageViewerStore;
